"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.getUUID = function () {
        var cookie = Utils.getCookie('UUID');
        // if uuid cookie was found return its value
        if (cookie !== undefined) {
            var key = 'UUID=';
            return cookie.substring(key.length);
        }
        return 'Default';
    };
    Utils.getCookie = function (cookieName) {
        var document;
        document = typeof document !== undefined ? document : undefined;
        var cookiesList = document && document.cookie ? document.cookie.split(';') : [''];
        // cookieName += '=';
        for (var _i = 0, cookiesList_1 = cookiesList; _i < cookiesList_1.length; _i++) {
            var cookie = cookiesList_1[_i];
            cookie = cookie.trim();
            // if cookie contains cookieName
            if (cookie.indexOf(cookieName) !== -1) {
                return cookie;
            }
        }
        return undefined;
    };
    Utils.getMtagCookie = function (cookieName) {
        var document;
        document = typeof document !== undefined ? document : undefined;
        var cookieNameKey = cookieName + '=';
        var cookiesList = document && document.cookie ? document.cookie.split(';') : [''];
        for (var _i = 0, cookiesList_2 = cookiesList; _i < cookiesList_2.length; _i++) {
            var cookie = cookiesList_2[_i];
            cookie = cookie.trim();
            if (cookie.indexOf(cookieNameKey) !== -1) {
                var cookieVal = cookie.substring(cookieNameKey.length, cookie.length);
                var zipFromCookie = this.getCookieData(cookieVal, 'zipCode') ? this.getCookieData(cookieVal, 'zipCode') : this.getCookieData(cookieVal, 'zip');
                return zipFromCookie;
            }
        }
        return undefined;
    };
    Utils.getCookieData = function (cookieData, key) {
        var data;
        try {
            data = cookieData.split(key + '=')[1].split('|')[0];
        }
        catch (err) {
            return '';
        }
        return data;
    };
    Utils.getMCID = function () {
        var mcid = visitor && visitor.getMarketingCloudVisitorID() ? visitor.getMarketingCloudVisitorID() : '';
        return mcid;
    };
    return Utils;
}());
exports.Utils = Utils;
var UIExperienceOptions;
(function (UIExperienceOptions) {
    UIExperienceOptions["Desktop"] = "Desktop";
    UIExperienceOptions["Smartphone"] = "Smartphone";
    UIExperienceOptions["Tablet"] = "Tablet";
})(UIExperienceOptions = exports.UIExperienceOptions || (exports.UIExperienceOptions = {}));
var SuccessFlags;
(function (SuccessFlags) {
    /** User’s action was successful */
    SuccessFlags[SuccessFlags["SUCCESSFUL"] = 1] = "SUCCESSFUL";
    /** User’s action unsuccessful
     * (system errors, e.g. back end system down or unrecognized user input/blank fields/etc.
     */
    SuccessFlags[SuccessFlags["UNSUCCESSFUL"] = 0] = "UNSUCCESSFUL";
    /** User cancelled the action */
    SuccessFlags[SuccessFlags["USER_CANCEL"] = -1] = "USER_CANCEL";
    /** Unknown */
    SuccessFlags[SuccessFlags["UNKNOWN"] = -2] = "UNKNOWN";
})(SuccessFlags = exports.SuccessFlags || (exports.SuccessFlags = {}));
var ErrorTypeOption;
(function (ErrorTypeOption) {
    ErrorTypeOption["Success_Admit"] = "Success_Admit";
    ErrorTypeOption["Planned_Downtime"] = "Planned_Downtime";
    ErrorTypeOption["Failure_BusinessRule"] = "Planned_Downtime";
    ErrorTypeOption["Failure_User"] = "Failure_User";
    ErrorTypeOption["Failure_System"] = "Failure_System";
    ErrorTypeOption["Failure_Data"] = "Failure_Data";
    ErrorTypeOption["UNKNOWN"] = "";
})(ErrorTypeOption = exports.ErrorTypeOption || (exports.ErrorTypeOption = {}));
var LinkPositionDataKeysOptions;
(function (LinkPositionDataKeysOptions) {
    LinkPositionDataKeysOptions["GLBN"] = "GLBN";
    LinkPositionDataKeysOptions["SUB_NAV"] = "SubNav";
    LinkPositionDataKeysOptions["LEFT_NAV"] = "LeftNav";
    LinkPositionDataKeysOptions["RIGHT_NAV"] = "RightNav";
    LinkPositionDataKeysOptions["BODY"] = "Body";
    LinkPositionDataKeysOptions["BODY_ALERTS"] = "Body_Alerts";
    LinkPositionDataKeysOptions["BODY_LOGIN_WIDGET"] = "Body_LoginWidget";
    LinkPositionDataKeysOptions["BODY_MESSAGE"] = "Body_Message";
    LinkPositionDataKeysOptions["MARQUEE"] = "Marquee";
    LinkPositionDataKeysOptions["CAROUSEL"] = "Carousel";
    LinkPositionDataKeysOptions["TAB"] = "Tab";
    LinkPositionDataKeysOptions["LINK_FARM"] = "LinkFarm";
    LinkPositionDataKeysOptions["FOOTER"] = "Footer";
    LinkPositionDataKeysOptions["HEADER"] = "Header";
    LinkPositionDataKeysOptions["QUICK_LINKS"] = "QuickLinks";
    LinkPositionDataKeysOptions["LINK_FARM_1"] = "LinkFarm_1";
    LinkPositionDataKeysOptions["LINK_FARM_2"] = "LinkFarm_2";
    LinkPositionDataKeysOptions["LINK_FARM_3"] = "LinkFarm_3";
})(LinkPositionDataKeysOptions = exports.LinkPositionDataKeysOptions || (exports.LinkPositionDataKeysOptions = {}));
var PaymentMethodFlags;
(function (PaymentMethodFlags) {
    PaymentMethodFlags["BilltoAccount"] = "Bill to Account";
    PaymentMethodFlags["Credit"] = "Credit";
    PaymentMethodFlags["Debit"] = "Debit";
    PaymentMethodFlags["NewCC"] = "New CC";
    PaymentMethodFlags["GiftCard"] = "Gift Card";
    PaymentMethodFlags["PaymentProfile"] = "Payment Profile";
    PaymentMethodFlags["UNKNOWN"] = "";
})(PaymentMethodFlags = exports.PaymentMethodFlags || (exports.PaymentMethodFlags = {}));
var CartFulfillMethodFlags;
(function (CartFulfillMethodFlags) {
    CartFulfillMethodFlags["Direct"] = "Direct";
    CartFulfillMethodFlags["Store"] = "Store";
    CartFulfillMethodFlags["Enjoy"] = "Enjoy";
    CartFulfillMethodFlags["UNKNOWN"] = "";
})(CartFulfillMethodFlags = exports.CartFulfillMethodFlags || (exports.CartFulfillMethodFlags = {}));
var PersistedCartFlag;
(function (PersistedCartFlag) {
    /* persisted cart */
    PersistedCartFlag[PersistedCartFlag["CONTAINS_DEVICES"] = 1] = "CONTAINS_DEVICES";
    /* non persisted cart*/
    PersistedCartFlag[PersistedCartFlag["NO_DEVICES"] = 0] = "NO_DEVICES";
})(PersistedCartFlag = exports.PersistedCartFlag || (exports.PersistedCartFlag = {}));
var AdvPaymentReqFlag;
(function (AdvPaymentReqFlag) {
    /* order placed requires advance payment */
    AdvPaymentReqFlag["ADVANCED_PAYMENT"] = "Y";
    /* non persisted cart*/
    AdvPaymentReqFlag["REG_PAYMENT"] = "N";
})(AdvPaymentReqFlag = exports.AdvPaymentReqFlag || (exports.AdvPaymentReqFlag = {}));
var ExistingWirelessAcctFlag;
(function (ExistingWirelessAcctFlag) {
    /* customer is an existing AT&T wireless customer */
    ExistingWirelessAcctFlag["EXIST_WIRELESS_CUSTOMER"] = "Y";
    /* New AT&T wireless customer */
    ExistingWirelessAcctFlag["NEW_WIRELESS_CUSTOMER"] = "N";
})(ExistingWirelessAcctFlag = exports.ExistingWirelessAcctFlag || (exports.ExistingWirelessAcctFlag = {}));
var NonRefundableFeeFlag;
(function (NonRefundableFeeFlag) {
    /* order placed requires non refundable fee */
    NonRefundableFeeFlag["NON_REFUNDABLE_FEE"] = "Y";
    /* non refundable fee is not required for order*/
    NonRefundableFeeFlag["NO_NON_REFUNDABLE_FEE"] = "N";
})(NonRefundableFeeFlag = exports.NonRefundableFeeFlag || (exports.NonRefundableFeeFlag = {}));
var RequiredAutoPayFlag;
(function (RequiredAutoPayFlag) {
    /* order placed requires auto payment */
    RequiredAutoPayFlag["AUTO_PAYMENT"] = "Y";
    /* auto payment is not required for order */
    RequiredAutoPayFlag["NO_AUTO_PAYMENT"] = "N";
})(RequiredAutoPayFlag = exports.RequiredAutoPayFlag || (exports.RequiredAutoPayFlag = {}));
var SecurityDepositReq;
(function (SecurityDepositReq) {
    /* order placed requires security deposit */
    SecurityDepositReq["SECURITY_DEPOSIT"] = "Y";
    /* security deposit is not required for order */
    SecurityDepositReq["NO_SECURITY_DEPOSIT"] = "N";
})(SecurityDepositReq = exports.SecurityDepositReq || (exports.SecurityDepositReq = {}));
var OfferSkuReferFlag;
(function (OfferSkuReferFlag) {
    /* if customer is not referred to MyATT Sales after clicking on a product offer/tile */
    OfferSkuReferFlag[OfferSkuReferFlag["NOT_FROM_MY_ATT_SERVICES"] = 0] = "NOT_FROM_MY_ATT_SERVICES";
    /* customer is referred to MyATT Sales after clicking on a product offer/tile from MyATT Services */
    OfferSkuReferFlag[OfferSkuReferFlag["FROM_MY_ATT_SERVICES"] = 1] = "FROM_MY_ATT_SERVICES";
})(OfferSkuReferFlag = exports.OfferSkuReferFlag || (exports.OfferSkuReferFlag = {}));
var CcAuthFlag;
(function (CcAuthFlag) {
    /* credit card authorization is not enabled */
    CcAuthFlag[CcAuthFlag["NO_CREDIT_CARD_AUTHORIZATION"] = 0] = "NO_CREDIT_CARD_AUTHORIZATION";
    /* credit card authorization is minimum enabled (in the backend) */
    CcAuthFlag[CcAuthFlag["MIN_CREDIT_CARD_AUTHORIZATION"] = 1] = "MIN_CREDIT_CARD_AUTHORIZATION";
    /* credit card authorization is enabled fully (in the backend) */
    CcAuthFlag[CcAuthFlag["FULL_CREDIT_CARD_AUTHORIZATION"] = 2] = "FULL_CREDIT_CARD_AUTHORIZATION";
})(CcAuthFlag = exports.CcAuthFlag || (exports.CcAuthFlag = {}));
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@login/analytics/utils.js
// module id = 582
// module chunks = 8